import React from 'react';
import { connect } from 'react-redux';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import * as eventChangeManagementActions from 'actions/inPersonTraining/eventOverview/eventChangeManagement';
import { Button, ButtonGroup } from 'ui';
import LinkButton from 'components/shared/LinkButton';

const UpdateEmailConfirmation = ({ sendUpdateEmail, onDismiss }) => {
  const [loading, setLoading] = React.useState(false);
  const [hasError, setError] = React.useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    setError(false);
    try {
      await sendUpdateEmail();
    } catch (err) {
      setLoading(false);
      setError(true);
    }
  };

  return (
    <AlertBox onDismiss={onDismiss}>
      {hasError && (
        <div className="ErrorContainer Animated Animated--fadeIn">
          {t('in_person_training.errors.submit_error')}
        </div>
      )}
      <Heading>
        {t('in_person_training.event_overview.update_email_confirmation')}
      </Heading>
      <ButtonGroup alignEnd>
        <LinkButton
          type="primary"
          className="mr-8"
          disabled={loading}
          onClick={onDismiss}
        >
          {t('common.do_not_send')}
        </LinkButton>
        <Button customColor loading={loading} onClick={handleConfirm}>
          {t('common.send')}
        </Button>
      </ButtonGroup>
    </AlertBox>
  );
};

const mapDispatchToProps = {
  sendUpdateEmail: eventChangeManagementActions.sendUpdateEmail,
  onDismiss: eventChangeManagementActions.toggleUpdateEmailConfirmation,
};

export default connect(null, mapDispatchToProps)(UpdateEmailConfirmation);
